import { MatchDetailsStylesSchema } from './NewMatchDetailsPage.styles';

export const matchDetailsStyles: MatchDetailsStylesSchema = {
  headerFlex: {
    flexDir: 'row',
    justify: 'space-between',
  },
  headerHeading: {
    alignItems: 'center',
    display: 'flex',
    flexDir: 'row',
    fontSize: 'lg',
    fontWeight: 'bold',
    fontFamily: 'accent',
    color: 'beta.300',
    textShadow: '0px 0px 8px rgba(254, 208, 119, 0.5)',
    textTransform: 'uppercase',
  },
  headerIconButton: {
    color: 'white',
    p: '1',
    size: 'xs',
    variant: 'link',
    _hover: {
      opacity: '.8',
    },
  },
  headerSkeletonText: {
    sx: {
      '.state-prior': { color: 'white' },
    },
  },
  headerVsBox: {
    color: 'alpha.100',
    textShadow: '0px 0px 8px rgba(254, 208, 119, 0.5)',
  },
  bodyStack: {
    color: 'white',
    p: '0',
    minH: '90vh',
  },
  bodyInnerWrapper: {
    alignItems: 'center',
    display: [null, null, null, 'flex'],
    justifyContent: 'space-between',
  },
  sgmLogo: {
    color: 'beta.300',
    h: '1.1em',
    ml: '2',
    mb: '0.5',
    w: 'auto',
  },

  scrollButtonGroup: {
    variant: 'filter',
    bg: 'none',
    boxShadow: 'none',
    sx: {
      '&&&': {
        mx: ['-2', null, null, '0'],
      },
    },
  },
  toMarketButton: {
    sx: {
      '&[data-active]': {
        _after: {
          pos: 'relative',
          top: 'unset',
          right: '-2px',
        },
      },
    },
    _last: { mr: 2 },
  },
  loadingSkeletonText: {
    my: '4',
    spacing: '4',
    skeletonHeight: '2',
  },
  accordion: {
    display: 'flex',
    flexDir: ['column', null, null, 'row'],
    mx: '-1',
  },
  accordionStack: {
    px: '1',
    w: { lg: '50%' },
    _notFirst: {
      mt: ['2', null, null, '0'],
    },
  },
  accordionItem: {
    bg: 'alpha.500',
    border: 'none',
    borderRadius: 'md',
    boxShadow:
      '0px 0px 0px 1px rgba(55, 140, 255, 0.50) inset, 0px 4px 10px 0px rgba(0, 0, 0, 0.30)',
    overflow: 'hidden',
  },
  accordionButton: {
    color: 'white',
    fontSize: 'sm',
    fontWeight: 'normal',
    fontFamily: 'Staatliches',
    p: '2',
    pos: 'relative',
    textAlign: 'left',
    _after: {
      borderBottomWidth: '1px',
      borderColor: 'blackAlpha.400',
      bottom: '0',
      boxShadow: '0 1px rgba(255, 255, 255, .07)',
      content: '""',
      left: '0',
      opacity: '0',
      pos: 'absolute',
      right: '0',
      transition: 'inherit',
      zIndex: '1',
    },
    _expanded: {
      _after: { opacity: '1' },
    },
    _hover: {
      bg: 'alpha.600',
    },
  },

  marketLayoutIconFlex: {
    align: 'center',
    flex: '1',
    gap: '1',
    fontSize: 'xs',
    fontWeight: 'bold',
    fontFamily: 'accent',
    textTransform: 'uppercase',
  },
  marketLayoutTooltip: {
    fontSize: 'xs',
  },
  marketLayoutIcon: {
    color: 'white',
    fontSize: 'lg',
  },
  marketLoadingCenter: {
    boxSize: '6',
  },
  centerLoadingSpinner: {
    color: 'white',
    size: 2,
  },
  marketLayoutLoadedIcon: {
    color: 'beta.300',
    fontSize: '2xl',
  },
  marketLayoutAccordionPanel: {
    p: '0',
  },
  cancelButton: {
    variant: 'solid',
    px: '3',
  },
  clearButton: {
    variant: 'solid',
    ml: '3',
    px: '3',
  },
  countdown: {
    sx: {
      textTransform: 'uppercase',
      '&&&.state-prior': {
        p: '1',
        lineHeight: 'initial',
      },
    },
  },
  sgmLogoV2: {
    color: 'white',
    w: '8',
    h: 'auto',
  },
  wrapperScrollSgm: { w: '100%', maxW: '100%', gap: '2', mt: '2' },
  scrollButtonGroupV2: {
    variant: 'unstyled',
    flex: 1,
    position: 'relative',
    minH: '34px',
    bg: 'blackAlpha.400',
    boxShadow:
      '0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.10)',
  },
  accordionItemActive: {
    bg: 'rgba(0, 209, 255, 0.25)',
    boxShadow:
      '0px 0px 0px 1px rgba(255, 255, 255, 0.2) inset,0px 4px 6px 0px rgba(0, 0, 0, 0.15)',
  },
  toMarketButtonV2: {
    color: 'white',
    fontSize: 'sm',
    textTransform: 'uppercase',
    minW: 'fit-content',
    fontWeight: 'bold',
    cursor: 'pointer',
    fontFamily: 'accent',

    sx: {
      '&&': {
        px: 2,
        ml: 0,
      },
      '&[data-active]': {
        color: 'beta.300',
      },

      '.chakra-button__icon': {
        margin: 0,
      },
    },

    _last: { mr: 2 },
  },
  sgmBtn: {
    bgGradient: 'linear(to-b, beta.300, beta.300)',
    h: '48px',
    border: 'none',
    sx: {
      svg: {
        color: 'white',
        fill: 'white',
      },
    },
  },
  sgmBtnActive: {
    sx: {
      svg: {
        color: 'beta.300',
        fill: 'beta.300',
      },

      '&&': {
        border: 'none',
        bg: 'alpha.800',
        boxShadow:
          '0px 2px 4px 0px rgba(0, 0, 0, 0.40) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.15)',
        textShadow: '0px 0px 8px rgba(251, 201, 21, 0.50)',
      },
    },

    _after: { display: 'none' },
  },
};
